// PageDescription: 의약품 사전 페이지
import MedicineDictionaryTemplate from '@/components/templates/medicine-dictionary/MedicineDictionaryTemplate';
import useMedicineDictionaryViewModel from '@/hooks/medicine-dictionary/useMedicineDictionaryViewModel';
import usePopularMedicineDictionaryItems from '@/hooks/medicine-dictionary/usePopularMedicineDictionaryItems';
import useGetKeywordIntegratedSearchMedicineDictionary from '@/hooks/search/useGetKeywordIntegratedSearchMedicineDictionary';
import { CustomPageProps } from '@/types/app';
import { ROUTES } from '@/types/common';
import { withClientServerSideProps } from '@/utils/mobile/RNPlugins';
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';

const MedicineDictionaryPage = ({ client }: CustomPageProps) => {
  const viewModel = useMedicineDictionaryViewModel();

  return (
    <>
      <NextSeo
        title={'닥터나우 의약품 사전 - 의약품 효능/효과부터 부작용까지'}
        description={
          '모든 의약품의 효과, 부작용, 복용법, 주의사항까지. 궁금한 약 정보를 닥터나우 의약품 사전에서 확인해보세요.'
        }
        canonical={`${process.env.NEXT_PUBLIC_DOMAIN}${ROUTES.MEDICINE_DICTIONARY.DETAIL.path}`}
      />
      <MedicineDictionaryTemplate viewModel={viewModel} client={client} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = withClientServerSideProps(async (context) => {
  const queryClient = new QueryClient();
  const page = Number(context.query.page) || 1;

  await Promise.allSettled([
    usePopularMedicineDictionaryItems.prefetchQuery(queryClient),
    useGetKeywordIntegratedSearchMedicineDictionary.prefetchQuery(queryClient, {
      keyword: undefined,
      limit: 10,
      page,
    }),
  ]);

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
      page,
    },
  };
});

export default MedicineDictionaryPage;
